import { post, get } from '../../../../services/request';

//-------------------Unread Exam Data - start----------------//
// Get all unread exam data
export const getAllUnreadData = (payload) => {
    return post(`ExamData/GetAllUnreadDataWithPagination`, payload);
};
//-------------------Unread Exam Data - end----------------//